import { store } from '@betacrew/jars-flux'
import { SSO_INTEGRATIONS_STATES } from './constants';

export const componentKey = "SSO_INTEGRATIONS";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setSsoIntegrationsLoaderState: (state, action) => {
            state.ssoIntegrationsLoaderState = action.payload;
        },
        setRedirectTo: (state, action) => {
            state.redirectTo = action.payload;
        },
    },
    initialReducerState: {
        ssoIntegrationsLoaderState: { state: SSO_INTEGRATIONS_STATES.SSO_INTEGRATION_LOADING },
        redirectTo: null,
    }
});
export const { setSsoIntegrationsLoaderState, setRedirectTo } = actions;